import { CircularProgress } from '@nexelem/components';
import { useAppBarHeight } from '@nexelem/appbar';

export type CommonLoaderProps = {
  height?: string | number;
  size?: number;
};
export const CommonLoader = ({ height, size = 100 }: CommonLoaderProps) => {
  const { heightWithoutAppBar } = useAppBarHeight();

  return (
    <div className="flex w-full items-center justify-center" style={{ height: height || heightWithoutAppBar }}>
      <CircularProgress size={size} />
    </div>
  );
};

CommonLoader.displayName = 'CommonLoader';
